import { useQuery } from '@apollo/client'
import { useContext, useEffect, useState } from 'react'
import {
  GET_DASHBOARD_ACTIVITY_WATER_TRUCK_REQUEST,
  GET_DATA_FOR_FILTERS_DASHBOARD_WATER_TRUCK_REQUEST,
} from '../../../../../../graphql/Catalog/WaterTruckRequest/Dashboard/dashboardActivityWaterTruckRequest'
import { GET_ALL_PROVIDERS } from '../../../../../../graphql/Catalog/Providers/providers'
import { GET_LAST_ONES_TIMELINES } from '../../../../../../graphql/Catalog/Timeline/timelines'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import CategoryFilter from '../../../../Documents/ReportsCounters/components/CategoryFilter'
import { AuthContext } from '../../../../../../Auth/AuthContext'
import { objNameRoles } from '../../../../../../const/constRoles'
import moment from 'moment'
import KpiCustomGraphicBar from '../../../../Documents/ReportsCounters/components/KpiCustomGraphicBar'
import { currencyFormatToAny } from '../../../../../Helpers/FormatNumber'
import KpiMultiCards from '../../../../Documents/ReportsCounters/components/KpiMultiCards'
import KpiCustomGraphicPie from '../../../../../../helpers/KpiCustomGraphicPie'
import _ from 'lodash'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import ActivityWaterTruckRequestPdfTemplate from './ActivityWaterTruckRequestPdfTemplate'

const DashboardActivityWaterTruckRequest = () => {
  const currentMonth = moment().format('MMMM')
  const currentYear = moment().format('YYYY')
  const currentWeek = moment().isoWeek()
  const MySwal = withReactContent(Swal)
  const monthsNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]
  const periodOptions = [
    { label: 'General', value: 'ALL' },
    { label: 'Ver por año', value: 'year' },
    // { label: 'Ver por mes', value: 'month' },
    { label: 'Ver por semana', value: 'week' },
    { label: 'Ver por día', value: 'day' },
  ]
  const { user } = useContext(AuthContext)
  const isPipeGestor = user && user.role === objNameRoles.gestor_pipas
  const isPipeProvider = user && user.role === objNameRoles.provedor_pipas
  const [counter, setCounter] = useState({
    counterByDateFilter: null,
    counterByDateFilterLines: null,
    counterByDateFilterOptions: null,
    cards: null,
    generated: null,
    resolved: null,
    effectiveness: null,
    pieGraphs: [
      {
        pieDataStatus: null,
        pieOptions: null,
        title: null,
        names: [],
        information: [],
      },
    ],
  })
  const [optionsProviders, setOptionsProviders] = useState([])
  const [groupBy, setGroupBy] = useState('ALL')
  const [labelSelected, setLabelSelected] = useState(null)
  const [periodSelected, setPeriodSelected] = useState()
  const [monthSelected, setMonthSelected] = useState(null)
  const [weekSelected, setWeekSelected] = useState(null)
  const [clearFilters, setClearFilters] = useState(false)
  const [NotLoading, setNotLoading] = useState(false)
  const [timeline, setTimeline] = useState({
    latest: [],
  })
  const [filters, setFilters] = useState({
    array_provider_id: null,
    // period: null,
    groupBy: 'ALL',
    start_date: null,
    end_date: null,
    year: '2025',
    month: null,
    week: null,
  })
  const [options, setOptions] = useState({
    labelsOptions: [],
    yearsOptions: [],
    thirdOptions: [],
  })
  const [pdfController, setPdfController] = useState({
    loading: false,
    hideElements: false,
    notes: null,
    title: 'Reporte de actividad de solicitudes de pipas',
  })
  const [providersName, setProvidersName] = useState([])
  const [year, setYear] = useState(moment().format('YYYY'))
  const [month, setMonth] = useState(null)
  const [week, setWeek] = useState(null)

  const {
    data: dataRequestCounters,
    loading: loadingRequestCounters,
    error: errorRequestCounters,
  } = useQuery(GET_DASHBOARD_ACTIVITY_WATER_TRUCK_REQUEST, {
    variables: { filters: filters },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataOptionsProviders,
    loading: loadingOptionsProviders,
    error: errorOptionsProviders,
  } = useQuery(GET_ALL_PROVIDERS, {
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataTimeline,
    loading: loadingTimeline,
    error: errorTimeline,
  } = useQuery(GET_LAST_ONES_TIMELINES, {
    variables: { category: ['water_truck_request'], limit: 10 },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataOptionsFilters,
    loading: loadingOptionsFilters,
    error: errorOptionsFilters,
  } = useQuery(GET_DATA_FOR_FILTERS_DASHBOARD_WATER_TRUCK_REQUEST, {
    variables: { filters: filters },
    fetchPolicy: 'no-cache',
    skip: NotLoading,
  })

  useEffect(() => {
    if (clearFilters) {
      setTimeout(() => {
        setClearFilters(false)
      }, 300)
    }
  }, [clearFilters])

  // useEffect(() => {)

  useEffect(() => {
    try {
      if (loadingRequestCounters) return
      if (errorRequestCounters) throw new Error(errorRequestCounters.message)
      const data = dataRequestCounters.getActivityWaterTruckRequestCountersByRol
      let counterByDateFilter = null
      let counterByDateFilterOptions = null
      let cards = null
      let pieGraphs = []
      const getLabels = handleGetLabels(groupBy, data)

      // if (getLabels.selectCurrentYear) setYear(getLabels.selectCurrentYear)
      // if (getLabels.selectCurrentMonth) setMonth(getLabels.selectCurrentMonth)
      // if (getLabels.selectCurrentWeek) setWeek(getLabels.selectCurrentWeek)

      // setOptions({
      //   ...options,
      //   labelsOptions: getLabels.options,
      // })
      const countersData = data.activityWaterTruckRequest.countersByDateFilter
      const getCountersForDateFilter = handleGetCountersForDateFilter(
        data.activityWaterTruckRequest,
        getLabels.labels,
        groupBy
      )

      counterByDateFilter = getCountersForDateFilter.counterByDateFilter
      counterByDateFilterOptions =
        getCountersForDateFilter.counterByDateFilterOptions

      if (!isPipeGestor) {
        const getCardName =
          data.activityWaterTruckRequest.reportsByProvider.map((item) => {
            return item.card_name
          })
        setProvidersName(getCardName)
      }

      if (isPipeGestor || (!isPipeGestor && !isPipeProvider)) {
        const getGraphsPieProvider = handleGetGraphsPie(
          data.activityWaterTruckRequest.reportsByProvider,
          'card_name',
          'Servicios realizados'
        )
        pieGraphs.push(getGraphsPieProvider)
        setProvidersName(getGraphsPieProvider.names)
      }
      const getGraphsPieTypeDelivery = handleGetGraphsPie(
        data.activityWaterTruckRequest.reportsByService,
        'type_delivery',
        'Reportes por servicio'
      )

      pieGraphs.push(getGraphsPieTypeDelivery)
      setCounter({
        counterByDateFilter,
        counterByDateFilterOptions,
        resolved: data.activityWaterTruckRequest.completed,
        generated: data.activityWaterTruckRequest.total,
        effectiveness: data.activityWaterTruckRequest.averageCompleted / 100,
        canceled: data.activityWaterTruckRequest.canceled,
        averageCanceled: data.activityWaterTruckRequest.averageCanceled,
        cards: [
          {
            title: 'Solicitudes canceladas',
            value: currencyFormatToAny({
              value: data.activityWaterTruckRequest.canceled,
              decimalsMax: 0,
              decimalsMin: 0,
            }),
            percentageSpan: (
              <span
                className="badge badge-secondary"
                style={{
                  fontSize: '0.8rem',
                  marginLeft: '5px',
                  padding: '2px 5px',
                  borderRadius: '5px',
                  backgroundColor: '#FFCDA2',
                  color: '#6c757d',
                }}
              >
                ({' '}
                {currencyFormatToAny({
                  value: data.activityWaterTruckRequest.averageCanceled / 100,
                  style: 'percent',
                  decimalsMax: 0,
                  decimalsMin: 0,
                })}
                )
              </span>
            ),
            percentage: currencyFormatToAny({
              value: data.activityWaterTruckRequest.averageCanceled / 100,
              style: 'percent',
              decimalsMax: 0,
              decimalsMin: 0,
            }),
            iconContent: <i className="fas fa-times colorRed" />,
          },
        ],
        pieGraphs: pieGraphs,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingRequestCounters, errorRequestCounters, dataRequestCounters])

  useEffect(() => {
    try {
      if (loadingOptionsProviders) return
      if (errorOptionsProviders) throw new Error(errorOptionsProviders.message)
      const listProviders = dataOptionsProviders.getAllProviders.rows.map(
        (item) => {
          return {
            label: `${item.card_name} (${item.card_code})`,
            value: item.id,
          }
        }
      )

      setOptionsProviders(listProviders)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingOptionsProviders, errorOptionsProviders, dataOptionsProviders])

  useEffect(() => {
    try {
      if (loadingTimeline) return
      if (errorTimeline) throw new Error(errorTimeline.message)
      setTimeline({
        latest: dataTimeline.getLastOnesTimelines,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTimeline, errorTimeline, dataTimeline])

  // useEffect(() => {
  //   if (labelSelected) {
  //     const pieGraphs = []

  //     const data = dataRequestCounters.getActivityWaterTruckRequestCountersByRol

  //     const findCounter =
  //       data.activityWaterTruckRequest.countersByDateFilter.filter(
  //         (item) => item.label === labelSelected
  //       )

  //     const getCountersForDateFilter = handleGetCountersForDateFilter(
  //       findCounter,
  //       [labelSelected]
  //     )

  //     const groupedProviders = findCounter[0].reportsByProvider.reduce(
  //       (acc, item) => {
  //         if (!acc[item.provider_id]) {
  //           acc[item.provider_id] = {
  //             provider_id: item.provider_id,
  //             card_name: item.card_name,
  //             total: 0,
  //             percentage: 0,
  //           }
  //         }

  //         acc[item.provider_id].total += item.total
  //         acc[item.provider_id].percentage =
  //           (acc[item.provider_id].total / findCounter[0].generated) * 100

  //         return acc
  //       },
  //       {}
  //     )

  //     const groupedServices = findCounter[0].reportsByService.reduce(
  //       (acc, item) => {
  //         if (!acc[item.type_delivery]) {
  //           acc[item.type_delivery] = {
  //             type_delivery: item.type_delivery,
  //             total: 0,
  //             percentage: 0,
  //           }
  //         }
  //         acc[item.type_delivery].total += item.count
  //         acc[item.type_delivery].percentage =
  //           (acc[item.type_delivery].total / findCounter[0].generated) * 100

  //         return acc
  //       },
  //       {}
  //     )

  //     //convert object to array
  //     const reportsByProvider = Object.values(groupedProviders)
  //     const reportsByService = Object.values(groupedServices)

  //     if (isPipeGestor) {
  //       const getGraphsPieProvider = handleGetGraphsPie(
  //         reportsByProvider,
  //         'card_name',
  //         'Cumplimiento por proveedor'
  //       )

  //       pieGraphs.push(getGraphsPieProvider)
  //       setProvidersName(getGraphsPieProvider.names)
  //     }

  //     const getGraphsPieTypeDelivery = handleGetGraphsPie(
  //       reportsByService,
  //       'type_delivery',
  //       'Reportes por servicio'
  //     )
  //     pieGraphs.push(getGraphsPieTypeDelivery)

  //     setCounter({
  //       ...counter,
  //       counterByDateFilter: getCountersForDateFilter.counterByDateFilter,
  //       counterByDateFilterOptions:
  //         getCountersForDateFilter.counterByDateFilterOptions,
  //       pieGraphs: pieGraphs,
  //       resolved: findCounter[0].resolved,
  //       generated: findCounter[0].generated,
  //       effectiveness: findCounter[0].effectivity / 100,
  //       canceled: findCounter[0].canceled,
  //       averageCanceled: findCounter[0].averageCanceled,
  //       cards: [
  //         {
  //           title: 'Solicitudes canceladas',
  //           value: (
  //             <>
  //               {findCounter[0].canceled}
  //               <span
  //                 className="badge badge-secondary"
  //                 style={{
  //                   fontSize: '0.8rem',
  //                   marginLeft: '5px',
  //                   padding: '2px 5px',
  //                   borderRadius: '5px',
  //                   backgroundColor: '#FFCDA2',
  //                   color: '#6c757d',
  //                 }}
  //               >
  //                 ({' '}
  //                 {currencyFormatToAny({
  //                   value: findCounter[0].averageCanceled / 100,
  //                   style: 'percent',
  //                   decimalsMax: 0,
  //                   decimalsMin: 0,
  //                 })}
  //                 )
  //               </span>
  //             </>
  //           ),
  //           iconContent: <i className="fas fa-times colorRed" />,
  //         },
  //       ],
  //     })
  //   }
  // }, [labelSelected])

  useEffect(() => {
    if (groupBy !== 'ALL') {
      setNotLoading(false)
    }
  }, [groupBy])

  useEffect(() => {
    try {
      if (NotLoading) return
      if (loadingOptionsFilters) return
      if (errorOptionsFilters) throw new Error(errorOptionsFilters.message)
      const data = dataOptionsFilters.getActivityWaterTruckRequestFilteres

      const arrayMonths = data.months
      const arrayWeeks = data.weeks
      const arrayYears = data.years
      if (groupBy !== 'ALL') setYear(data.years[0])

      switch (groupBy) {
        case 'year':
          setMonth(null)
          setWeek(null)
          setLabelSelected(data.years[0].label)
          break
        // case 'month':
        //   setMonth(data.months[0].value)
        //   setWeek(null)
        //   setLabelSelected(data.months[0].label)
        //   break
        case 'week':
          setMonth(data.months[0].value)
          setFilters({
            ...filters,
            month: data.months[0].value,
          })
          // setWeek(data.weeks[0].value)
          // setLabelSelected(data.weeks[0].label)
          break
        case 'day':
          // setMonth(data.months[0].value)
          setWeek(data.weeks[0].value)
          setFilters({
            ...filters,
            // month: data.months[0].value,
            week: data.weeks[0].value,
          })
          // setLabelSelected(data.weeks[0].label)
          break
      }

      setOptions({
        ...options,
        yearsOptions: arrayYears,
        thirdOptions:
          groupBy === 'year'
            ? []
            : groupBy === 'week'
            ? arrayMonths
            : groupBy === 'day'
            ? arrayWeeks
            : [],
      })
      setNotLoading(true)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataOptionsFilters, loadingOptionsFilters, errorOptionsFilters])

  const handleChangeFilter = (selected) => {
    if (selected) {
      setFilters({
        ...filters,
        month: groupBy === 'week' ? selected.value : null,
        week: groupBy === 'day' ? selected.value : null,
      })
    }

    if (!selected) {
      setFilters({
        ...filters,
        month: null,
        week: null,
      })
    }
  }

  const handleChangeFilterPeriod = (selected) => {
    if (selected) {
      setFilters({
        ...filters,
        // period: selected.value,
        groupBy: selected.value,
      })
      setGroupBy(selected.value)
      // setPeriodSelected(selected.value)
    }

    if (!selected) {
      setFilters({
        ...filters,
        // period: null,
        groupBy: null,
      })
      setPeriodSelected(null)
      setGroupBy('ALL')
    }
  }

  const handleChangeFilterYear = (selected) => {
    if (selected) {
      setFilters({
        ...filters,
        year: String(selected.value),
      })
      // setGroupBy(selected.value)
      setOptions({
        ...options,
        labelsOptions: [],
      })
    }

    if (!selected) {
      setFilters({
        ...filters,
        year: null,
      })
      setGroupBy('ALL')
    }
  }

  const handleGetLabels = (group, data) => {
    let labels = []
    let labelsOptions = []
    let selectCurrentYear = false
    let selectCurrentMonth = false
    let selectCurrentWeek = false
    if (!group) group = 'ALL'
    switch (group) {
      case 'day':
        labels = data.activityWaterTruckRequest.labels
        break
      case 'year':
        labels = data.activityWaterTruckRequest.labels
        break
      case 'week':
        labels = data.activityWaterTruckRequest.labels
        break
      case 'ALL':
        labels = ['Todos los registros']
        break
    }

    return {
      labels: labels,
      // options: labelsOptions,
      // selectCurrentYear: selectCurrentYear,
      // selectCurrentMonth: selectCurrentMonth,
      // selectCurrentWeek: selectCurrentWeek,
    }
  }

  const handleGetCountersForDateFilter = (data, labels, groupBy) => {
    try {
      let counterByDateFilter = null
      let counterByDateFilterOptions = null
      const dataSets = []

      switch (groupBy) {
        case 'day':
        case 'week':
        case 'year':
          data.reportsByProvider.forEach((item) => {
            // Para cada proveedor, vamos a agrupar por fecha (mes o semana)
            const dataGenerated = labels.map((label) => {
              const dateMatch = item.dataDates.find((d) => d.label === label)
              return dateMatch ? dateMatch.generated : 0
            })

            const dataResolved = labels.map((label) => {
              const dateMatch = item.dataDates.find((d) => d.label === label)
              return dateMatch ? dateMatch.completed : 0
            })

            // Dataset para generados
            dataSets.push({
              label: `Generados por ${
                item.card_name
                  ? item.card_name.length > 20
                    ? item.card_name.substring(0, 5) + '...'
                    : item.card_name
                  : ''
              }`,
              data: dataGenerated,
              backgroundColor: item.provider_id === 5 ? '#4B5563' : '#83919B',
              borderColor: item.provider_id === 5 ? '#4B5563' : '#83919B',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: 'generated',
            })

            // Dataset para Atendidos
            dataSets.push({
              label: `Atendidos por ${
                item.card_name
                  ? item.card_name.length > 20
                    ? item.card_name.substring(0, 5) + '...'
                    : item.card_name
                  : ''
              }`,
              data: dataResolved,
              backgroundColor: item.provider_id === 5 ? '#F97316' : '#FE8E47',
              borderColor: item.provider_id === 5 ? '#F97316' : '#FE8E47',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: 'resolved',
            })
          })
          break
        case 'ALL':
          // Generamos un dataset para cada proveedor
          data.reportsByProvider.forEach((item) => {
            dataSets.push({
              label: `Generados por ${
                item.card_name
                  ? item.card_name.length > 20
                    ? item.card_name.substring(0, 5)
                    : item.card_name
                  : ''
              }`,
              data: [item.total],
              backgroundColor: item.provider_id === 5 ? '#4B5563' : '#6F7C88',
              borderColor: item.provider_id === 5 ? '#4B5563' : '#83919B',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: `generated`,
            })
            dataSets.push({
              label: `Atendidos por ${
                item.card_name
                  ? item.card_name.length > 20
                    ? item.card_name.substring(0, 5)
                    : item.card_name
                  : ''
              }`,
              data: [item.resolved],
              backgroundColor: item.provider_id === 5 ? '#F97316' : '#FE8E47',
              borderColor: item.provider_id === 5 ? '#F97316' : '#FE8E47',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: `resolved`,
            })
          })
          break
      }

      counterByDateFilter = {
        labels: labels,
        datasets: dataSets,
        // datasets: [
        //   // {
        //   //   label: 'Generados',
        //   //   data: dataSetsProviderTotal,
        //   //   // data: data.countersByDateFilter.map((item) => item.generated),
        //   //   backgroundColor: '#F97316',
        //   //   borderColor: '#F97316',
        //   //   borderWidth: 1,
        //   //   maxBarThickness: 140,
        //   //   stack: 'Stack 0',
        //   // },
        //   // {
        //   //   label: 'Atendidos',
        //   //   data: dataSetsProviderResolved,
        //   //   // data: data.countersByDateFilter.map((item) => item.resolved),
        //   //   backgroundColor: '#8c8c8c',
        //   //   borderColor: '#8c8c8c',
        //   //   borderWidth: 1,
        //   //   maxBarThickness: 140,
        //   //   stack: 'Stack 0',
        //   // },
        // ],
      }

      counterByDateFilterOptions = {
        responsive: true,
        // maintainAspectRatio: false,
        // animation: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                color: '#4B5563',
                size: 15,
              },
            },
            //NO REPEAT LEGEND
          },
          datalabels: {
            // anchor: 'end',
            // align: 'top',
            formatter: (value) =>
              currencyFormatToAny({
                value: value,
                decimalsMax: 0,
                decimalsMin: 0,
              }),
            color: (value) => {
              if (value.dataset.label.includes('Generados')) {
                return '#fff'
              } else if (value.dataset.label.includes('Atendidos')) {
                return '#000'
              }
            },
            font: {
              weight: 'bold',
            },
          },
        },
        scales: {
          y: {
            // stacked: true,
            beginAtZero: true,
          },
          x: {
            // stacked: true,
            ticks: {
              color: '#4A4A4A', // Cambiar color de las etiquetas
              font: {
                size: 15, // Cambiar tamaño de fuente
                weight: 'bold', // Cambiar peso de la fuente
              },
            },
          },
        },
      }
      return {
        counterByDateFilter,
        counterByDateFilterOptions,
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleGetGraphsPie = (data, fieldName, title) => {
    try {
      let names = []
      let information = []
      information = data.map((item) => {
        return {
          value: item.total,
          label: item[fieldName],
        }
      })
      const pieDataStatus = {
        labels: data.map((item) => {
          if (!names.includes(item[fieldName])) {
            names.push(
              item[fieldName].charAt(0).toUpperCase() + item[fieldName].slice(1)
            )
          }
          return item[fieldName].length > 20
            ? item[fieldName].charAt(0).toUpperCase() +
                item[fieldName].slice(1).substring(0, 10) +
                '...'
            : item[fieldName].charAt(0).toUpperCase() + item[fieldName].slice(1)
        }),
        datasets: [
          {
            // label: fieldName,
            data: data.map((item) => item.percentage.toFixed(2)),
            backgroundColor: ['#F97316', '#FE8E47'],
            hoverBackgroundColor: ['#F97316', '#FE8E47', '#FEA35E'],
            // borderColor: ['#F97316', '#FC8C3C'],
            // borderWidth: 1,
          },
        ],
      }

      const pieOptions = {
        responsive: true,
        maintainAspectRatio: false,
        padding: 0,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              font: {
                color: '#4B5563',
                size: 12,
              },
            },
          },
          datalabels: {
            // display: true,
            anchor: 'end',
            align: 'start',
            formatter: function (value) {
              return value + '%'
            },
            color: '#fff',
            font: {
              weight: 'bold',
            },
            backgroundColor: '#00000099',
            borderRadius: 5,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem) {
                const label = tooltipItem.label
                const value = tooltipItem.formattedValue
                return `${label}: ${value}%`
              },
            },
          },
        },
        scales: {
          y: {
            display: false, // Ocultar eje Y
          },
          x: {
            display: false, // Ocultar eje X
            ticks: {
              color: '#4A4A4A', // Cambiar color de las etiquetas
              font: {
                size: 15, // Cambiar tamaño de fuente
                weight: 'bold', // Cambiar peso de la fuente
              },
            },
          },
        },
      }

      return { pieDataStatus, pieOptions, title, names, information }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleGeneratePdf = () => {
    //Add notes modal
    MySwal.fire({
      title: 'Exportar reporte',
      html: (
        <>
          <div className="message-container d-flex flex-column gap-3 mt-3">
            <div className="d-flex text-left gap-3" style={{ width: '100%' }}>
              <div className="input-container" style={{ width: '99%' }}>
                <label htmlFor="notes-area" style={{ paddingLeft: '4px' }}>
                  Añadir alguna observación
                </label>
                <br />
                <textarea
                  name="notes-area"
                  id="notes-area"
                  placeholder="Escribe aquí"
                  style={{
                    width: '100%',
                    height: '150px',
                    borderColor: '#CED4DA',
                    borderRadius: '12px',
                    padding: '10px',
                  }}
                  maxLength={500}
                ></textarea>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-migrates mt-1 mr-3"
              onClick={() => document.querySelector('.swal2-confirm')?.click()}
            >
              Exportar reporte
            </button>
          </div>
        </>
      ),
      allowOutsideClick: true,
      buttonsStyling: false,
      showDenyButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Exportar reporte',
      denyButtonText: 'Cancelar',
      customClass: {
        title: 'StandarModalTitleBackgroundNone',
        htmlContainer: 'StandarModalHtmlContainer standarModalAvoidFooter',
        confirmButton: 'btn btn-migrates d-none',
        footer: 'btn StandarModalFooterLogOut',
      },
      preConfirm: () => {
        const notes = document.getElementById('notes-area')?.value
        return {
          notes,
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed && result.value) {
          setPdfController({
            ...pdfController,
            notes: result.value?.notes,
            loading: true,
            hideElements: true,
          })
          let timerInterval
          MySwal.fire({
            title: 'Generando PDF',
            html: 'Esto tomará un momento',
            timer: 1000,
            timerProgressBar: true,
            didOpen: () => Swal.showLoading(),
            willClose: () => clearInterval(timerInterval),
          })
        }
      })
      .catch((error) => {})
  }

  const getLabelDay = (label, year, month, week) => {
    let date = ''
    if (!label) return 'Todos los registros'
    if (week) {
      date = moment(label, 'dddd')
        .isoWeekYear(year)
        .isoWeek(week)
        .startOf('isoWeek')
      while (date.format('dddd') !== label) {
        date = date.add(1, 'day')
      }
    } else {
      return (
        <>
          {' '}
          {label
            ? `Día ${label.charAt(0).toUpperCase()}${label.slice(1)} ${
                year && !month ? 'Anual' : ''
              } ${month && 'por mes'}`
            : month
            ? 'Mensual por día'
            : 'Anual por semana'}
          <br />
          {month ? 'Mes ' + monthsNames[month - 1] : ''}
          {month ? <br /> : ''}
          Año {year}
        </>
      )
    }

    return date.format('dddd, D [de] MMMM [de] YYYY')
  }

  const getMonthLabel = (week, year) => {
    const numberWeek = Number(week)
    const numberYear = Number(year)
    const date = moment()
      .isoWeekYear(numberYear)
      .isoWeek(numberWeek)
      .startOf('isoWeek')
    const month = date.format('MMMM')
    return ` ${month.charAt(0).toUpperCase()}${month.slice(1)}`
  }

  const handleClearFilters = () => {
    setClearFilters(true)
    setPeriodSelected(null)
    setGroupBy('ALL')
    setLabelSelected(null)
    setFilters({
      ...filters,
      array_provider_id: null,
      period: null,
      groupBy: null,
      start_date: null,
      end_date: null,
    })
    setOptions({
      ...options,
      labelsOptions: [],
      thirdOptions: [],
    })
    setYear(moment().format('YYYY'))
    setMonth(null)
    setWeek(null)
  }
  return (
    <>
      {pdfController.hideElements ? (
        <div>
          <ActivityWaterTruckRequestPdfTemplate
            filters={filters}
            setPdfController={setPdfController}
            pdfController={pdfController}
            counter={counter}
            periodSelected={periodSelected}
            groupBy={groupBy}
            year={year}
            providersName={providersName}
          />
        </div>
      ) : (
        <div className={`row px-3 py-3 dashboard-activity-water-truck-request`}>
          <div className="col-12 header-box">
            <span className="text-center">
              Aquí tienes un resumen de lo que está pasando el día de hoy.
            </span>
            <button className='btn btn-purple' onClick={handleGeneratePdf}>Descargar reporte</button>
          </div>

          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 filters-box">
            <div className="row mb-4">
              {!clearFilters && (
                <CategoryFilter
                  titleContent={
                    <label>
                      Agrupar por <small>(Selecciona una opcion)</small>
                    </label>
                  }
                  options={periodOptions}
                  onChange={handleChangeFilterPeriod}
                  isMulti={false}
                  showValue
                  value={periodOptions.find((item) => item.value === groupBy)}
                />
              )}

              {filters?.groupBy !== 'ALL' && (
                <CategoryFilter
                  titleContent={
                    <label>
                      Año <small>(Selecciona una opcion)</small>
                    </label>
                  }
                  options={options.yearsOptions}
                  onChange={handleChangeFilterYear}
                  isMulti={false}
                  showValue
                  value={{ value: filters.year, label: filters.year }}
                />
              )}

              {options.thirdOptions.length > 0 && (
                <CategoryFilter
                  titleContent={
                    <label>
                      {groupBy === 'day'
                        ? 'Por semana'
                        : groupBy === 'week'
                        ? 'Por mes'
                        : 'Por todos los registros'}

                      <small> (Selecciona una opcion)</small>
                    </label>
                  }
                  options={options.thirdOptions}
                  onChange={(selected) => handleChangeFilter(selected)}
                  isMulti={false}
                  showValue
                  value={
                    groupBy === 'day'
                      ? options.thirdOptions.find(
                          (item) => item.value === filters.week
                        )
                      : groupBy === 'week'
                      ? options.thirdOptions.find(
                          (item) => item.value === filters.month
                        )
                      : null
                  }
                />
              )}
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 counters-graphics-box">
            {/** Counters and Pie Graphics */}
            <div className="row mb-3 graphics-box-container-pie">
              <div
                className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 cards-box`}
              >
                <KpiMultiCards cards={counter?.cards} />
              </div>
              {counter?.pieGraphs && counter?.pieGraphs.length > 0 && (
                <>
                  {counter?.pieGraphs.map((item, index) => (
                    <div
                      key={index}
                      className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 pie-item`}
                    >
                      <div className="row graphics-box graphics-boxPie">
                        <div className="header">
                          <h5 className="text-left">{item.title}</h5>
                        </div>
                        <div className="body">
                          <div className="legend d-flex flex-row justify-content-xl-around">
                            {item?.information &&
                              item?.information.length > 0 &&
                              item.information.map((itemLegend, index) => (
                                <div
                                  key={index}
                                  className="legend-item ml-2 mr-3"
                                >
                                  <h5>
                                    {/* {itemLegend.label.length > 20
                                      ? itemLegend.label.substring(0, 7) + '...'
                                      : itemLegend.label} */}
                                    {itemLegend.label}
                                  </h5>
                                  <p>
                                    {currencyFormatToAny({
                                      value: itemLegend.value,
                                      decimalsMax: 0,
                                      decimalsMin: 0,
                                    })}
                                  </p>
                                </div>
                              ))}
                          </div>
                          <KpiCustomGraphicPie
                            pieDataStatus={item.pieDataStatus}
                            pieOptions={item.pieOptions}
                          />
                        </div>{' '}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>

            {/** Bar Graphics */}
            <div className="row graphics-box-container counters-page-break graphics-box-container-bar">
              {counter?.counterByDateFilter && (
                <div className="graphics-box col-12">
                  <div className="header">
                    <h5 className="text-left">
                      Actividad de solicitudes de pipas{' '}
                      {groupBy === 'day'
                        ? 'por día'
                        : groupBy === 'month'
                        ? 'por mes'
                        : groupBy === 'year'
                        ? 'por año'
                        : groupBy === 'week'
                        ? 'por semana'
                        : 'por todos los registros'}
                    </h5>
                  </div>
                  <div className="body">
                    <div className="legend d-flex flex-row justify-content-xl-around">
                      <div className="legend-item ml-2">
                        <h5>Generados</h5>
                        <p>
                          {currencyFormatToAny({
                            value: counter?.generated,
                            decimalsMax: 0,
                            decimalsMin: 0,
                          })}
                        </p>
                      </div>
                      <div className="legend-item ml-2">
                        <h5>Atendidos</h5>
                        <p>
                          {' '}
                          {currencyFormatToAny({
                            value: counter?.resolved,
                            decimalsMax: 0,
                            decimalsMin: 0,
                          })}
                        </p>
                      </div>
                      <div className="legend-item ml-2">
                        <h5>Efectividad</h5>
                        <p>
                          {' '}
                          {currencyFormatToAny({
                            value: counter?.effectiveness,
                            style: 'percent',
                            // roundMax: true,
                            // roundMin: true,
                          })}
                        </p>
                      </div>
                    </div>
                    <div className="chart">
                      <KpiCustomGraphicBar
                        barDataStatus={counter?.counterByDateFilter}
                        barOptions={counter?.counterByDateFilterOptions}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default DashboardActivityWaterTruckRequest
